import { Vue, Component, Prop } from "vue-property-decorator";
import { IActivationUser,IUpsertActivationUsers } from "@/models";
import { Modal, FormSelect } from "@/components";

// TODO changer les noms
@Component({
    components: { Modal, FormSelect },
})
export default class ModalAccess extends Vue {

    @Prop({required: true})
    public state: boolean;

    @Prop()
    public title: string;

    @Prop()
    public subTitle: string;

    @Prop({required: true})
    public activationId: number;

    @Prop({required: true})
    public getter: string;

    @Prop({required: true})
    public loadAction: string;

    @Prop({required: true})
    public saveAction: string;

    public isLoading = false;

    public users: IActivationUser[] = [];

    public selectedUsersIds: number[] = [];

    public usersIdsToBeRemoved: number[] = [];

    public get accessGrantedUsers(): IActivationUser[] {
        return this.users?.filter(u => u.accessGranted)?.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())) ?? [];
    }

    public get selectableUsers(): IActivationUser[] {
        return this.users?.filter(u => !u.accessGranted).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())) ?? [];
    }

    public flagUserForRemoval(userId: number): void {
        this.usersIdsToBeRemoved.push(userId);
    }

    public cancelRemoval(userId: number): void {
        this.usersIdsToBeRemoved = this.usersIdsToBeRemoved?.filter(id => id !== userId);
    }

    public isFlaggedForRemoval(userId: number): boolean {
        return this.usersIdsToBeRemoved.some(id => id === userId);
    }

    // TODO sort
    public async mounted(): Promise<void>{
        await this.loadUsers();
    }

    public setAccess(): void {
        this.users = this.users.map(u => {
            const user = this.selectedUsersIds.find(uId => u.userId === uId);
            if(user){
                u.accessGranted = true;
                u.notificationsEnabled = true;
            }
            return u;
        });
    }

    public removeAccess(): void {
        this.users = this.users.map(u => {
            const toBeRemoved = this.usersIdsToBeRemoved.some(id => u.userId === id);
            if(toBeRemoved){
                u.accessGranted = false;
                u.notificationsEnabled = false;
            }
            this.selectedUsersIds = this.selectedUsersIds?.filter(id => id !== u.userId);
            return u;
        });
    }

    public async save(): Promise<void> {
        try {

            this.isLoading = true;

            this.removeAccess();

            const activationUsers = this.accessGrantedUsers.map( u => {
                const item: IActivationUser = {
                    activationId: this.activationId,
                    userId: u.userId,
                    accessGranted: u.accessGranted,
                    email: u.email,
                    notificationsEnabled: u.notificationsEnabled,
                    openNotifReceived: u.openNotifReceived,
                };
                return item;
            });

            const upsertActivation: IUpsertActivationUsers = {
                activationId: this.activationId,
                users: activationUsers,
            };

            await this.$store.dispatch(this.saveAction, upsertActivation);
            this.usersIdsToBeRemoved = [];
            this.$notify({ type: "success", duration: 5000, text: "Access set successfully"});
        }
        catch {
            this.$notify({ type: "error", duration: 5000, text: "Error while setting access"});
        }
        finally {
            await this.loadUsers();
            this.isLoading = false;
        }
    }


    public async closeModal(): Promise<void> {
        this.usersIdsToBeRemoved = [];
        this.selectedUsersIds = [];
        await this.loadUsers();
        this.$emit("close");
    }

    public getMailTo(email: string): string {
        return `mailTo:${email}`;
    }

    private async loadUsers(): Promise<void> {

        this.isLoading = true;

        await this.$store.dispatch(this.loadAction, this.activationId);
        this.users = this.$store.getters[this.getter];

        const currentUser = this.$store.getters["account/user"];
        this.users = this.users?.filter(u => u.userId !== currentUser.userId);

        this.isLoading = false;

    }

}
